export type PolygonNameValidation =
    | { readonly kind: 'ok'; readonly name: string }
    | { readonly kind: 'noop' }
    | { readonly kind: 'error'; readonly message: string };

export const validatePolygonName = (input: string, currentName: string, allNames: ReadonlyArray<string>): PolygonNameValidation => {
    const name = input.trim();
    if (name === '') {
        return { kind: 'error', message: 'Polygon name is required.' };
    }
    if (name === currentName) {
        return { kind: 'noop' };
    }
    if (allNames.includes(name)) {
        return { kind: 'error', message: 'A polygon with this name already exists in this project.' };
    }
    return { kind: 'ok', name };
};
